import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

import { trackClick } from 'utils/AnalyticsUtils';
import { LocalTimeShort } from 'modules/Common/components/LocalDateTime';
import CompactText from 'modules/Common/components/CompactText';
import SubscriptionContainer from 'modules/Common/containers/Subscriptions/SubscriptionContainer';
import StarButton from 'modules/Common/containers/Subscriptions/StarButton';
import { MATCH_STATE_UPNEXT, MATCH_STATE_LIVE, MATCH_STATE_FINISHED } from 'modules/Football/consts';
import { SUBSCRIPTIONS_FOOTBALL_MATCH } from 'modules/Common/consts';
import {titleToId} from 'utils/url-rewrite';
import FootballMatchOutcomeDescription from 'modules/Football/components/FootballMatchOutcomeDescription';
import FootballMatchOdds from 'modules/Football/components/FootballMatchOdds';


require("./FootballMatchListItem.scss");

function hasScores(teamAScore, teamBScore) {
  return teamAScore !== undefined && teamBScore !== undefined;
}

function generateScoreString(teamAScore, teamBScore) {
  if (hasScores(teamAScore, teamBScore)) {
    return `${teamAScore} - ${teamBScore}`;
  } else {
    return "v";
  }
}

function generateScoreClasses(matchState, teamAScore, teamBScore) {
  if (MATCH_STATE_LIVE.includes(matchState) && hasScores(teamAScore, teamBScore)) {
    return "scoreString matchInProgressOrHalfTime";
  } else {
    return "scoreString matchNotStartedOrFullTime"
  }
}

function showAggregateScore(teamAAggregate, teamBAggregate) {
  return teamAAggregate !== undefined && teamBAggregate !== undefined;
}

export default function FootballMatchListItem({
  match,
  match: {
    team_score_a: {
      team: {
        name: teamAName,
        short_name: teamAShortName
      } = {},
      score: [
        {
          score: teamAScore
        } = {}
      ] = [{}],
      aggregate_score: teamAAggregate
    } = {},
    team_score_b: {
      team: {
        name: teamBName,
        short_name: teamBShortName
      } = {},
      score: [
        {
          score: teamBScore
        } = {}
      ] = [{}],
      aggregate_score: teamBAggregate
    } = {},
    match_reference: {
      id: matchId
    } = {},
    match_outcome: matchOutcome,
    penalty_shootout_score: penaltyShootoutScore,
    state: matchState,
    match_date: matchDate,
    clock: matchClock
  } = {}
} = {}) {
  return (
    <div className="footballMatchListItem">
      <div className="topRow">
        <div className="matchTime">
          {
            matchClock ?
              <div className="liveScoreMinutes">{matchClock}</div>
            :
              <LocalTimeShort iso={matchDate}/>
          }
        </div>
        <Link to={`/football/live/${matchId}/commentary`}>
          <div className="matchInformation">
            <div className="liveScoresTeamScores">
              <div className="teamA" id={titleToId(teamAName)}><CompactText compactText={teamAShortName}>{teamAName}</CompactText></div>
              <div className={generateScoreClasses(matchState, teamAScore, teamBScore)}>{generateScoreString(teamAScore, teamBScore)}</div>
              <div className="teamB" id={titleToId(teamBName)}><CompactText compactText={teamBShortName}>{teamBName}</CompactText></div>
            </div>
            {showAggregateScore(teamAAggregate, teamBAggregate) && <div className="liveScoresAggregateScores">(Agg: {teamAAggregate}-{teamBAggregate})</div>}
            <FootballMatchOutcomeDescription matchOutcome={matchOutcome} penaltyShootoutScore={penaltyShootoutScore}/>
          </div>
        </Link>
        <div className="favourite">
          <SubscriptionContainer
            addSubscriptions={ [{
              type: SUBSCRIPTIONS_FOOTBALL_MATCH,
              id: matchId,
              text: `${teamAName} v ${teamBName}`
            }] }
            icon={
              <StarButton
                trackClick={trackClick("followMatch", { matchId }, true)}
                selectedTitle="Remove from My Scores"
                deselectedTitle="Add to My Scores"
                hideIfDeselected={MATCH_STATE_FINISHED.includes(matchState)}
              />
            }
          />
        </div>
      </div>
      <FootballMatchOdds match={match} />
    </div>
  );
}

FootballMatchListItem.propTypes = {
  match: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./modules/Football/components/FootballMatchListItem.js